import { Box, Divider, Typography, Grid, Stack } from '@mui/material';

import React, { useEffect, useMemo, useState } from 'react';
import { Icon } from '@iconify/react';
import { useParams } from 'react-router-dom';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { useSelector } from 'react-redux';
import { getDeliveryDetail, getRegistrationDetail } from '../../services/registration';
import { updateOfacDetails } from '../../services/inventory';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';

import { Tabs } from '../../components';
import TabContent from './TabContent';
import Link from '../../components/Link/Link';
import Registration from '../Registration';
import { currencyFormat } from '../../utils/string';
import { RootState } from '../../redux/store';

const StageInfo = () => {
  const { reservationId } = useParams<{ reservationId: string }>();
  const [deliveryData, setDeliveryData] = useState<any>();
  const [registrationData, setRegistartionData] = useState<any>();
  const vehicle = useSelector((state: RootState) => state.vehicle.data);

  useEffect(() => {
    if (reservationId) {
      getDeliveryDetail(reservationId as string).then((response) => setDeliveryData(response));
      getRegistrationDetail(reservationId as string).then((response) => setRegistartionData(response));
      // updateOfacDetails(vehicle.orderId as string);
    }
  }, [reservationId]);

  const tabItems = useMemo(() => {
    const data = { ...registrationData, ...deliveryData };
    return [
      {
        label: 'Delivery',
        content: (
          <TabContent module={META_DATA_MODULES.v360Page} subModule={META_DATA_SUB_MODULES.deliveryTab} data={data} />
        ),
      },
      {
        label: 'Registration',
        content: <Registration data={data} />,
      },

      {
        label: 'DMV',
        content: (
          <TabContent module={META_DATA_MODULES.v360Page} subModule={META_DATA_SUB_MODULES.DMVTab} data={data} />
        ),
      },
      {
        label: 'KYC / OFAC',
        content: (
          <Box sx={{ width: '100%' }}>
            <Grid>
              <Typography
                sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '24px', padding: '10px 10px 0px 10px' }}
              >
                Buyer
              </Typography>

              <TableContainer
                component={Paper}
                sx={{
                  my: '10px',
                  border: '1px solid #e3e3e3',
                  borderRadius: '4px',
                  borderBottom: '0',
                  boxShadow: 'none',
                }}
              >
                <Table aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#f2f2f2',
                          width: '50%',
                        }}
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          OFAC Status
                        </Typography>
                      </TableCell>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#fff',
                        }}
                        align="right"
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          {data?.OFAC?.OFACStatusBuyer ? data?.OFAC?.OFACStatusBuyer : '--'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#f2f2f2',
                          width: '50%',
                        }}
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          OFAC Sub Status
                        </Typography>
                      </TableCell>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#fff',
                        }}
                        align="right"
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          {data?.OFAC?.OFACSubStatusBuyer ? data?.OFAC?.OFACSubStatusBuyer : '--'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#f2f2f2',
                          width: '50%',
                        }}
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          OFAC Last Checked Date
                        </Typography>
                      </TableCell>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#fff',
                        }}
                        align="right"
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          {data?.OFAC?.OFACLastCheckDateBuyer
                            ? new Date(data?.OFAC?.OFACLastCheckDateBuyer).toLocaleDateString()
                            : '--'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            {data.CheckIfCoBuyer === 'true' && (
              <Grid>
                <Typography
                  sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '24px', padding: '10px 10px 0px 10px' }}
                >
                  Co Buyer
                </Typography>

                <TableContainer
                  component={Paper}
                  sx={{
                    my: '10px',
                    border: '1px solid #e3e3e3',
                    borderRadius: '4px',
                    borderBottom: '0',
                    boxShadow: 'none',
                  }}
                >
                  <Table aria-label="simple table">
                    <TableBody>
                      <TableRow>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#f2f2f2',
                            width: '50%',
                          }}
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            OFAC Status
                          </Typography>
                        </TableCell>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#fff',
                          }}
                          align="right"
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            {data?.OFAC?.OFACStatusCoBuyer ? data?.OFAC?.OFACStatusCoBuyer : '--'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#f2f2f2',
                            width: '50%',
                          }}
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            OFAC Sub Status
                          </Typography>
                        </TableCell>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#fff',
                          }}
                          align="right"
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            {data?.OFAC?.OFACSubStatusCoBuyer ? data?.OFAC?.OFACSubStatusCoBuyer : '--'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#f2f2f2',
                            width: '50%',
                          }}
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            OFAC Last Checked Date
                          </Typography>
                        </TableCell>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#fff',
                          }}
                          align="right"
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            {data?.OFAC?.OFACLastCheckDateCoBuyer
                              ? new Date(data?.OFAC?.OFACLastCheckDateCoBuyer).toLocaleDateString()
                              : '--'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
            {(data.RegistrationType === 'Business' || data.RegistrationType === 'Trust') && (
              <Grid>
                <Typography
                  sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '24px', padding: '10px 10px 0px 10px' }}
                >
                  {data.RegistrationType}
                </Typography>

                <TableContainer
                  component={Paper}
                  sx={{
                    my: '10px',
                    border: '1px solid #e3e3e3',
                    borderRadius: '4px',
                    borderBottom: '0',
                    boxShadow: 'none',
                  }}
                >
                  <Table aria-label="simple table">
                    <TableBody>
                      <TableRow>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#f2f2f2',
                            width: '50%',
                          }}
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            OFAC Status
                          </Typography>
                        </TableCell>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#fff',
                          }}
                          align="right"
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            {data?.OFAC?.OFACStatusBusinessOrTrust ? data?.OFAC?.OFACStatusBusinessOrTrust : '--'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#f2f2f2',
                            width: '50%',
                          }}
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            OFAC Sub Status
                          </Typography>
                        </TableCell>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#fff',
                          }}
                          align="right"
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            {data?.OFAC?.OFACSubStatusBusinessOrTrust ? data?.OFAC?.OFACSubStatusBusinessOrTrust : '--'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#f2f2f2',
                            width: '50%',
                          }}
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            OFAC Last Checked Date
                          </Typography>
                        </TableCell>
                        <TableCell
                          component="td"
                          scope="row"
                          sx={{
                            padding: '7px 10px',
                            fontSize: '12px',
                            background: '#fff',
                          }}
                          align="right"
                        >
                          <Typography fontWeight={500} fontSize={14}>
                            {data?.OFAC?.OFACLastCheckDateBusinessOrTrust
                              ? new Date(data?.OFAC?.OFACLastCheckDateBusinessOrTrust).toLocaleDateString()
                              : '--'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
            <Grid>
              <Typography
                sx={{ fontSize: '14px', fontWeight: '500', lineHeight: '24px', padding: '10px 10px 0px 10px' }}
              >
                Summary
              </Typography>

              <TableContainer
                component={Paper}
                sx={{
                  my: '10px',
                  border: '1px solid #e3e3e3',
                  borderRadius: '4px',
                  borderBottom: '0',
                  boxShadow: 'none',
                }}
              >
                <Table aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#f2f2f2',
                          width: '50%',
                        }}
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          OFAC Notes
                        </Typography>
                      </TableCell>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#fff',
                        }}
                        align="right"
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          {data?.OFAC?.OFACNotes ? data?.OFAC?.OFACNotes : '--'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#f2f2f2',
                          width: '50%',
                        }}
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          OFAC Check Completed
                        </Typography>
                      </TableCell>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          padding: '7px 10px',
                          fontSize: '12px',
                          background: '#fff',
                        }}
                        align="right"
                      >
                        <Typography fontWeight={500} fontSize={14}>
                          {data?.OFAC?.OFACCheckCompleted}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Box>
        ),
      },
      {
        label: 'Insurance',
        content: (
          <TabContent module={META_DATA_MODULES.v360Page} subModule={META_DATA_SUB_MODULES.insuranceTab} data={data} />
        ),
      },
    ];
  }, [deliveryData, registrationData]);

  return (
    <Box sx={{ px: 2 }}>
      <Tabs tabItems={tabItems} />
    </Box>
  );
};

export default StageInfo;
